/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-restricted-globals */
import nookies from 'nookies';
import {
  AUTHENTICATED_WALLET_STATE_COOKIE_NAME,
  AUTHENTICATED_WALLET_INFO_STATE,
  registrationSources,
  AUTHENTICATED_SIGNED_MSG,
} from './const';
import {CookieName, LoggedWalletInfo, WalletState} from './types';

export const setCookie = (
  cookieKey: CookieName,
  cookieValue: string,
  maxAge = 3600, // 1 hour
): void => {
  nookies.set(null, cookieKey, cookieValue, {
    maxAge,
    path: '/',
    sameSite: undefined,
    secure: true,
  });
};

export const setSignatureCookies = (signature: string): void => {
  setCookie(AUTHENTICATED_SIGNED_MSG, signature);
};

export const setLoggedWalletInfo = (info: LoggedWalletInfo): void => {
  setCookie(AUTHENTICATED_WALLET_INFO_STATE, JSON.stringify(info));
};

export const sanitizeLoadedWalletState = (
  loadedWalletState: unknown,
): WalletState | null => {
  if (typeof loadedWalletState !== 'object') return null;

  const typedWalletState = loadedWalletState as Partial<WalletState>;

  if (
    !typedWalletState.address ||
    typeof typedWalletState.address !== 'string' ||
    !typedWalletState.address.startsWith('0x')
  )
    return null;

  if (
    !typedWalletState.provider ||
    !registrationSources.includes(typedWalletState.provider)
  )
    return null;

  if (!typedWalletState.chainId || typeof typedWalletState.chainId !== 'number')
    return null;

  return typedWalletState as WalletState;
};

export const getAuthenticatedWalletState = (): WalletState | null => {
  const stringifiedWalletState =
    nookies.get()[AUTHENTICATED_WALLET_STATE_COOKIE_NAME];

  if (!stringifiedWalletState) return null;

  const loadedWalletState = JSON.parse(stringifiedWalletState);

  return sanitizeLoadedWalletState(loadedWalletState);
};
